// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2qC1n","name":"Header_name__1qDwo","birthday":"Header_birthday__3Oxra","skeleton":"Header_skeleton__3UlfL"};